// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__1D5Yx borders_bottomShiny__2z5Tf"};